import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import axios from 'axios';

Vue.config.productionTip = false

axios.defaults.baseURL = process.env.VUE_APP_ROOT_API

// Add request interceptors
axios.interceptors.request.use((config) => {
  console.log('Request:', config);
  return config;
}, (error) => {
  console.log(error);
  return Promise.reject(error);
});

// Add response interceptors
axios.interceptors.response.use((response) => {
  console.log('Response:', response);
  return response;
}, (error) => {
  console.log(error);
  return Promise.reject(error);
});

Vue.prototype.$http = axios

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
